module.exports = __webpack_public_path__ + "img/zsgg-8.fa0e718c.png";